import { firebaseClient, getToken } from "../firebaseClient";
import async from "async";
import * as Sentry from "@sentry/nextjs";
import { getAccount, updateUser } from "../utils/sessionHelper";
import type { StateWithId as CarouselState } from "../types/carousel";
export const saveCarousel = async (carousel, idUser) => {
  try {
    const db = firebaseClient.firestore();
    if (!carousel.createdDate) {
      carousel.createdDate = new Date();
    }
    // If carousel.id is undefined, create a new document with an automatically generated ID
    const carouselRef = carousel.id
      ? db
        .collection("users")
        .doc(idUser)
        .collection("carousels")
        .doc(carousel.id)
      : db.collection("users").doc(idUser).collection("carousels").doc();

    await carouselRef.set(carousel);

    // Update carousel.id with the generated ID if it was undefined
    if (!carousel.id) {
      carousel.id = carouselRef.id;
      await carouselRef.update({ id: carousel.id });
    }

    // Return the saved carousel object
    return carousel;
  } catch (error) {
    console.error("Error saving carousel:", error);
    Sentry.captureException(error);
    return null; // Return null to indicate an error occurred during saving
  }
};

export const deleteCarousel = async (carouselId, idUser) => {
  try {
    const db = firebaseClient.firestore();
    await db
      .collection("users")
      .doc(idUser)
      .collection("carousels")
      .doc(carouselId)
      .delete();
  } catch (error) {
    console.error("Error deleting carousel:", error);
    Sentry.captureException(error);
  }
};

export const getCarouselsList = async (
  idUser: string | undefined
): Promise<CarouselState[]> => {
  try {
    const db = firebaseClient.firestore();
    const carousels = await db
      .collection("users")
      .doc(idUser)
      .collection("carousels")
      .orderBy("createdDate", "desc")
      .get();

    return carousels.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    })) as CarouselState[];
  } catch (error) {
    console.error("Error getting carousels:", error);
    Sentry.captureException(error);
    return [];
  }
};
